export const getPageMenuStyles = (pageMenu, { palette = {} }) => ({
  pageMenuContainer: {
    paddingTop: 7,
    width: '100%',
    backgroundColor: palette.neutralLighter,
    borderRight: `solid 1px ${palette.neutralQuaternaryAlt}`,
    position: 'absolute',
    top: 0,
    bottom: 0,
    overflowX: 'hidden',
    overflowY: 'hidden',
    '&:hover': {
      overflowY: 'auto',
    },
    '& .list-selector-item': {
      width: 163,
      position: 'relative',
      '&:focus': {
        outline: `1px solid ${palette.neutralSecondary}`,
        outlineOffset: -1,
      },
      '& > div': {
        width: 'unset',
        height: 'unset',
      },
    },
  },
  divider: {
    width: '100%',
    borderTop: `solid 1px ${palette.neutralQuaternaryAlt}`,
  },
  collapsedPageMenuContainer: {
    '& .list-selector-item': {
      width: 47,
    },
  },
});
